<template>
  <div class="md:pt-12 lg:pt-12 pt-0 md:pb-12 lg:pb-12 pb-12 relative z-index1">
    <div class="absolute bg-faq-dots z-index--1 mob-hidden">
      <img
        src="../../../assets/images/caregiver/faq-dots.svg"
        alt="bg-polygon"
        class="w-full"
      />
    </div>
    <!-- <div class="absolute bg-faq-poly1 z-index--1 mob-hidden">
      <img
        src="../../../assets/images/caregiver/faq-poly1.svg"
        alt="bg-polygon"
        class="w-full"
      />
    </div> -->
    <div class="absolute bg-faq-poly2 z-index--1 mob-hidden">
      <img
        src="../../../assets/images/caregiver/faq-poly2.svg"
        alt="bg-polygon"
        class="w-full"
      />
    </div>
    <div class="w-full mx-auto lg:px-12 md:px-12 px-5">
      <p
        class="title w-full sm-fsize16 lg:font-medium md:font-medium font-bold"
      >
        FAQ's
      </p>

      <div
        class="md:mt-10 lg:mt-10 mt-4 md:py-6 lg:py-6 py-4 md:px-8 lg:px-8 px-4 cust-shadow-FAQ rounded-lg bg-white z-10"
        v-for="(item, index) in faq"
        :key="index"
      >
        <div
          class="flex items-center w-full justify-between cursor-pointer"
          block
          v-b-toggle="'accordion-' + index"
        >
          <p class="subtitle txt-FAQ-A fsize20-14px">
            {{ item.que }}
          </p>
          <img
            src="../../../assets/images/caregiver/downIcon.svg"
            alt="Downicon"
            class="md:h-4 lg:h-4 h-2 w-6"
          />
        </div>
        <b-collapse
          :id="'accordion-' + index"
          accordion="my-accordion"
          role="tabpanel"
        >
          <p class="subtitle pt-8 fsize20-14px">
            {{ item.answer }}
          </p>
        </b-collapse>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      faq: [
        {
          id: "01",
          que: "How do I request for a particular service?",
          answer:
            "Please fill in the details in the form above we will get back to you. ",
        },
        {
          id: "02",
          que: "When will I receive a response?",
          answer:
            "Our team will get back to you within 24 - 48 hours after submission of your request. ",
        },
        {
          id: "03",
          que: "Can I avail the service at my location in my city?",
          answer:
            "Our well-being services are currently offered virtually. For other services, we have partners pan-india to deliver the same. We will try our best to accommodate your request. ",
        },
        {
          id: "04",
          que: "What is the cost of these services?",
          answer:
            "As the services will be customised as per your requirement, we will share the rates after assessing your request. ",
        },
      ],
    };
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
